import type { ExperienceManifest } from '../../types'

export const manifest: ExperienceManifest = {
  version: '1.0.0',
  schemaVersion: '1.0.0',
  minimumFrameworkVersion: '1.0.0',
  capabilities: {
    supportsAudio: false,
    supportsInteraction: true,
    supportsReplay: true,
    supportsReducedMotion: true,
    supportsLocalization: false,
    supportsAnalytics: true,
    supportsCelebration: false,
  },
  metadata: {
    id: 'mission-control',
    name: 'Mission Control Dashboard',
    description: 'A premium spacecraft-telemetry diagnostics console visualizing system readiness.',
    category: 'entrance',
    themePreference: 'dark',
  },
  eligibility: {
    check: (context) => context.user.currentStreak > 0,
    cooldownMs: 24 * 60 * 60 * 1000,
    basePriority: 70,
  },
  ComponentLoader: () => import('./component'),
  preload: async () => Promise.resolve(),
}

export default manifest
